import { render, staticRenderFns } from "./relatorio-procedimentos.vue?vue&type=template&id=1914fe0e&scoped=true"
import script from "./relatorio-procedimentos.vue?vue&type=script&lang=js"
export * from "./relatorio-procedimentos.vue?vue&type=script&lang=js"
import style0 from "./relatorio-procedimentos.vue?vue&type=style&index=0&id=1914fe0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1914fe0e",
  null
  
)

export default component.exports